import React, { FunctionComponent } from 'react';
// TODO Amina delete relatives imports
import { ContactICon } from '../../icons/ContactICon';
import { WarrantiesIcon } from '../../icons/WarrantiesIcon';
import { BackToIcon } from '../../icons/BackToIcon';
import { HelpContactIcon } from '../../icons/HelpContactIcon';
import { RecycleIcon } from '../../icons/RecycleIcon';
import { Description } from './Description';
import { WarrantiesLabel } from './WarantiesLabel';
import { RenderSellerServiceItem } from './RenderSellerServiceItem';
import { LAYER_TYPE } from '@/utils/constants';
import { MkpSeller } from "@/models/scope/productSheet/mkpSeller/MkpSeller";
import {
    dispatchProductSheetReturnConditionsHandleClick,
    dispatchProductSheetSellerNameHandleClick
} from "@/animations/responsive/productPageTracking";
import {Offers} from "@/models/scope/productSheet/offer/Offers";

interface Props {
    seller: MkpSeller | undefined;
    offerList: Offers | null,
    offerWarranty: number | undefined;
    offerWarrantyUnit: string | undefined;
    state: string | undefined;
    handleClick: (layerType: string) => void;
}

const SERVICE_TYPE = {
    DESCRIPTION: 'Commentaire du vendeur',
    BACK_TO: 'Retour',
    WARRANTY: 'garantie',
    RECYCLE: 'Reprise de votre ancien produit',
    QUESTION: 'Une question sur votre commande ?',
};

export const SellerServiceLayer: FunctionComponent<Props> = ({
    seller,
    offerList,
    offerWarranty,
    offerWarrantyUnit,
    state,
    handleClick
}) => {
    if (!seller) {
        return null;
    }


    const renderDescription = () => {
        const description = offerList?.items[offerList?.winningOfferIndex].description
        if (description) {
            return (
                <RenderSellerServiceItem
                    type={SERVICE_TYPE.DESCRIPTION}
                    icon={<ContactICon/>}
                >
                    <Description description={description}/>
                </RenderSellerServiceItem>
            );
        }
    };

    const renderBackTo = () => {
        return (
            <RenderSellerServiceItem
                type={SERVICE_TYPE.BACK_TO}
                icon={<BackToIcon />}
            >
                <p>
                    Les produits Marketplace sont vendus par nos vendeurs partenaires et
                    ne sont pas exposés en magasin. Ils sont exclusivement livrables à
                    domicile. En cas de retour, ce produit vendu par{' '}
                    <a
                        className='link'
                        onClick={() => {
                            window.open(
                                `${seller?.sheetUrl}`,
                                '_blank',
                                'noopener,noreferrer',
                            );
                            dispatchProductSheetSellerNameHandleClick(`Clic nom vendeur FP ${seller?.shopName}`)
                        }}
                    >
                        {` ${seller?.shopName} `}
                    </a>
                    ne pourra pas être retourné en magasin BUT.
                    <a
                        className='link'
                        onClick={() => {
                            window.open(
                                `${seller?.sheetUrl}`,
                                '_blank',
                                'noopener,noreferrer',
                            );
                            dispatchProductSheetReturnConditionsHandleClick()
                        }}
                    >
                        {' '}
                        Voir les conditions de retour
                    </a>
                </p>
            </RenderSellerServiceItem>
        );
    };

    const renderWarranties = () => {
        return (
            <RenderSellerServiceItem
                type={SERVICE_TYPE.WARRANTY}
                icon={<WarrantiesIcon />}
            >
                <WarrantiesLabel
                    offerWarranty={offerWarranty}
                    offerWarrantyUnit={offerWarrantyUnit}
                    state={state}
                />
            </RenderSellerServiceItem>
        );
    };

    const renderRecycle = () => {
        return (
            <RenderSellerServiceItem
                type={SERVICE_TYPE.RECYCLE}
                icon={<RecycleIcon />}
            >
                <p>
                    Ce produit peut être éligible à la reprise.
                    <span
                        className='link'
                        onClick={() => handleClick(LAYER_TYPE.OLD_PRODUCT)}
                    >
                        {' '}
                        Voir les modalités
                    </span>
                </p>
            </RenderSellerServiceItem>
        );
    };

    const renderQuestion = () => {
        return (
            <RenderSellerServiceItem
                type={SERVICE_TYPE.QUESTION}
                icon={<HelpContactIcon />}
                isGreyBackground={true}
            >
                <p>
                    Le vendeur et l'équipe BUT vous répondent via la messagerie de votre
                    espace client.
                </p>
            </RenderSellerServiceItem>
        );
    };

    return (
        <div className='seller-service-layer'>
            <p className='country-label'>
                Pays d'expedition :
                <span className='country-name'> {seller?.shippingCountry}</span>
            </p>
            {renderDescription()}
            {renderBackTo()}
            {renderWarranties()}
            {renderRecycle()}
            {renderQuestion()}
        </div>
    );
};
